import { withInstall as o } from "../../utils/with-install.js";
import t from "./button-group.vue.js";
/* empty css                  */
import { buttonGroupContextKey as f, buttonGroupProps as u } from "./button-group.js";
o(t);
export {
  f as buttonGroupContextKey,
  u as buttonGroupProps
};
